module.exports = __webpack_public_path__ + "img/teams.23b5f118.jpg";